import core from '@/helpers/client'
import Vue from 'vue'
import { eventBus } from '@/main.js'

const filecloudService = {
  async uploadImageAsync(data) {
    try {
      const result = await core.upload(
        `${process.env.VUE_APP_BASE_URL_FILE_UPLOAD}api/v1/Files`,
        data
      )
      eventBus.$emit('changeLoadingState', false)
      return result
    } catch (error) {
      eventBus.$emit('changeLoadingState', false)
      return error
    }
  },
  async deleteFileByUrl(url) {
    const accessToken = Vue.$cookies.get('.at')
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_URL_FILE_UPLOAD}api/v1/Files?url=${encodeURI(
        url
      )}`,
      {},
      { headers: { Authorization: `Bearer ${accessToken}` } }
    )
    return result
  },
}
export default filecloudService
